// Client API pour les fiches PCG (LOT 1 — Step 1.7).
//
// Point d'entrée unique côté frontend pour parler à `/api/accounts`.
// L'URL de base vient exclusivement de `process.env.REACT_APP_BACKEND_URL` ;
// aucune valeur en dur.

const API = process.env.REACT_APP_BACKEND_URL;

if (!API) {
  console.error(
    "REACT_APP_BACKEND_URL non défini — le client PCG ne pourra pas fetch les comptes."
  );
}

/**
 * Récupère toutes les fiches PCG en une passe (dataset ~843 fiches).
 * Sert de bootstrap au démarrage de l'app.
 */
export async function fetchAllAccounts() {
  const res = await fetch(`${API}/api/accounts?limit=2000`);
  if (!res.ok) {
    throw new Error(`fetchAllAccounts a échoué : HTTP ${res.status}`);
  }
  const body = await res.json();
  return body.items || [];
}

/**
 * Récupère une fiche par numéro. Retourne `null` si 404.
 */
export async function fetchAccountByNum(num) {
  const res = await fetch(`${API}/api/accounts/${encodeURIComponent(num)}`);
  if (res.status === 404) return null;
  if (!res.ok) {
    throw new Error(`fetchAccountByNum(${num}) a échoué : HTTP ${res.status}`);
  }
  return res.json();
}

/**
 * Compteurs agrégés (dashboard interne).
 */
export async function fetchAccountsStats() {
  const res = await fetch(`${API}/api/accounts/stats`);
  if (!res.ok) {
    throw new Error(`fetchAccountsStats a échoué : HTTP ${res.status}`);
  }
  return res.json();
}
